import { initAnimatedElements } from "./features/animated-elements";
import { initCookieBanner } from "./features/cookie-banner";
import { initCustomSelects } from "./features/custom-select";
import { initDisclaimerModal } from "./features/disclaimer-modal";
import { initDocumentLinks } from "./features/document-links";
import { initNavbar } from "./features/navbar";
import {
  hasPerformanceCharts,
  initPerformanceCharts
} from "./features/performance-charts";
import { initShareModal } from "./features/share-modal";
import { initTabsMenuScroll } from "./features/tabs-menu";
import { initTeamModal } from "./features/team-modal";
import { initVideoModal } from "./features/video-modal";

export async function bootstrap() {
  initAnimatedElements();
  initCookieBanner();
  initCustomSelects();
  initDisclaimerModal();
  initDocumentLinks();
  initNavbar();
  initShareModal();
  initTabsMenuScroll();
  initTeamModal();
  initVideoModal();

  if (isPerformancePage()) {
    setTimeout(function() {
      initPerformanceCharts();
    }, 500);
  }
}

function isPerformancePage() {
  return window.location.pathname.indexOf("performance") !== -1 ||
    hasPerformanceCharts();
}
